import React from "react";

const Editar = () => {
    return;
}

export default Editar;